import { clsx } from 'clsx';
import { Field } from 'react-final-form';
import { Text } from '@belong/ui';

const STAR_COUNT = 5;

type StarRatingFieldProps = {
  name: string;
  validate?: (value: number | undefined) => string | undefined;
};

function StarIcon({ filled }: { filled: boolean }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={clsx('h-2xl w-2xl', filled ? 'text-yellow' : 'text-gray')}
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M12 2.5l2.94 5.96 6.58.96-4.76 4.64 1.12 6.55L12 17.6l-5.88 3.01 1.12-6.55L2.48 9.42l6.58-.96L12 2.5z"
      />
    </svg>
  );
}

export function StarRatingField({ name, validate }: StarRatingFieldProps) {
  return (
    <Field<number | undefined> name={name} validate={validate}>
      {({ input, meta }) => (
        <div>
          <div className="flex gap-xs">
            {Array.from({ length: STAR_COUNT }, (_, i) => {
              const starValue = i + 1;
              const filled =
                input.value !== undefined &&
                input.value !== ('' as unknown as number) &&
                starValue <= (input.value as number);
              return (
                <button
                  key={starValue}
                  type="button"
                  onClick={() => input.onChange(starValue)}
                  onBlur={input.onBlur}
                  className="rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-navy"
                  aria-label={`${starValue} star${starValue !== 1 ? 's' : ''}`}
                >
                  <StarIcon filled={filled} />
                </button>
              );
            })}
          </div>
          {meta.touched && meta.error && (
            <Text className="mt-xs text-red">{meta.error}</Text>
          )}
        </div>
      )}
    </Field>
  );
}
